import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BenefitsData } from '../../showcase-benefits/showcase-benefits.component';

export interface SectionProfileData {
  cards: Array<any>;
  description: string;
  events: Array<any>;
  itens: Array<any>;
  subtitle: string;
  title: string;
  type: string;
}

@Component({
  selector: 'fcp-section-profile',
  templateUrl: 'section-profile.component.html',
  styleUrls: ['./section-profile.component.scss']
})

export class SectionProfileComponent {
  public profilesData: Array<SectionProfileData>;
  @Input() public profiles;

  /*
  @Input() public set profiles(value: Array<SectionProfileData>) {
    const profiles = value ? value : [];
    this.profilesData = profiles.filter((val) => val.type !== '');
  }*/

  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();

  public clicked(value) {
    this.wasClicked.emit(value);
  }

}
